import { useLazyQuery, useMutation } from "@apollo/client/react";
import { gql } from "@apollo/client";
import toast from "react-hot-toast";
import { AuthorizationCheckRequired, eventBus } from "@/state";

const gqlGetFlagDefinitions = gql`
  query flags($orgId: UUID!) {
    flagDefinitions(orgId: $orgId) {
      description
      flagId
      restrictions
      name
    }
  }
`;



const gqlGetObjectFlags = gql`
  query objectFlags($orgId: UUID!, $objectId: String!) {
    objectFlags(orgId: $orgId, objectId: $objectId) {
      flagId
      id {
        creationTime
        timestamp
        toByteArray
      }
      metadata {
        key
        value
      }
      objectId
      sourceId
    }
  }
`;

const FLAG_DETAILS = {
    "FLAG_PENDING_FINANCIAL_TRANSACTION": {
        name: "Pending Financial Transaction",
        description: "Application has pending payments or financial transactions that must be completed before making changes",
        restrictions: ["RESTRICT_DELETES"]
    },
    "FLAG_OPEN_BALANCE": {
        name: "Open Balance",
        description: "Tenant has outstanding balance that needs to be resolved",
        restrictions: ["RESTRICT_DELETES", "RESTRICT_STATUS_CHANGE"]
    },
    "FLAG_PENDING_BACKGROUND_CHECK": {
        name: "Pending Background Check",
        description: "Background screening is in progress and results are pending",
        restrictions: ["RESTRICT_APPROVAL", "RESTRICT_LEASE_GENERATION"]
    },
    "FLAG_ACTIVE_LEASE": {
        name: "Active Lease",
        description: "Application has an active lease agreement in effect",
        restrictions: ["RESTRICT_DELETES", "RESTRICT_TENANT_REMOVAL"]
    },
    "FLAG_PENDING_DEPOSIT": {
        name: "Pending Deposit",
        description: "Security deposit payment is required before proceeding",
        restrictions: ["RESTRICT_MOVES", "RESTRICT_APPROVAL"]
    },
    "FLAG_INCOMPLETE_APPLICATION": {
        name: "Incomplete Application",
        description: "Required application information or documentation is missing",
        restrictions: ["RESTRICT_APPROVAL", "RESTRICT_LEASE_GENERATION"]
    },
    "FLAG_PENDING_VERIFICATION": {
        name: "Pending Verification",
        description: "Income, employment, or reference verification is pending",
        restrictions: ["RESTRICT_APPROVAL", "RESTRICT_AUTO_RENEWAL"]
    }
};

// Enrich flag instances with their definition details
function enrichFlagInstances(instances) {
    return instances.map(instance => ({
        ...instance,
        name: FLAG_DETAILS[instance.flagId]?.name || instance.flagId,
        description: FLAG_DETAILS[instance.flagId]?.description || "",
        restrictions: FLAG_DETAILS[instance.flagId]?.restrictions || []
    }));
}


export function useFlagActions() {

    const [apiGetFlagsDefinition] = useLazyQuery(gqlGetFlagDefinitions);
    const [apiGetObjectFlags] = useLazyQuery(gqlGetObjectFlags);
    // const [apiDeleteTag] = useMutation(deleteTagMutation);
    // const [apiGetResourceTags] = useLazyQuery(getResourceTagsQuery);

   

    function GetObjectFlags(organizationId: string, objectId: string) {
        if(!organizationId) throw "No organization selected";
        if(!objectId) throw "No Object selected";

        return new Promise(async (resolve, reject) => {
            apiGetObjectFlags({variables: {orgId: organizationId, objectId: objectId},})
            .then((result: any) => enrichFlagInstances(result?.data?.objectFlags))
            .then((result) => resolve(result))
            .catch((err) => {
                let data =  JSON.parse(JSON.stringify(err))
                
                if(data?.message?.includes("user is not authorized"))
                {
                    eventBus.next({type: AuthorizationCheckRequired})
                }

                toast.error("Api Error, Unable to get object flag details");
                reject(err);
            })
        })
    }

    function GetFlagsDefinition(organizationId: string) {
        if(!organizationId) throw "No organization selected";

        return new Promise(async (resolve, reject) => {
            apiGetFlagsDefinition()
            .then((result: any) => result?.data?.flagDefinitions)
            .then((result) => resolve(result))
            .catch((err) => {
                let data =  JSON.parse(JSON.stringify(err))
                if(data?.message?.includes("user is not authorized"))
                {
                    eventBus.next({type: AuthorizationCheckRequired})
                }

                toast.error("Api Error, Unable to get flag defintions");
                reject(err);
            })
        })
    }


    
    return {
        GetFlagsDefinition,
        GetObjectFlags
    };
}




